<template>
  <path
    d="M16.5 4.00024H7.56C6.7 4.00024 6 4.70024 6 5.56024C6 5.84024 6.12 6.11024 6.32 6.30024L12.5 12.0002L6.32 17.7002C6.12 17.8902 6 18.1602 6 18.4402C6 19.3002 6.7 20.0002 7.56 20.0002H16.5C17.33 20.0002 18 19.3302 18 18.5002C18 17.6702 17.33 17.0002 16.5 17.0002H11L14.59 13.4102C15.37 12.6302 15.37 11.3602 14.59 10.5802L11 7.00024H16.5C17.33 7.00024 18 6.33024 18 5.50024C18 4.67024 17.33 4.00024 16.5 4.00024Z"
  />
</template>
